import React from "react"
import Figures from "./figures"
import { graphql, useStaticQuery } from "gatsby"

const figs = [
  {
    _typename: "thumbnail",
    reference: "1",
    image: "I01",
    size: 2,
    caption_en: {
      title: "April in the Laurentians",
      body: ", c. 1922-1924<br/>Oil on canvas<br/>50,9 x 61,5 cm",
      source: "Collection of the National Gallery of Canada, Ottawa<br/>Gift of Anne McDougall, Ottawa, 1997<br/>Photo: NGC",
    },
    caption_fr: {
      title: "Avril dans les Laurentides",
      body: ", vers 1922-1924<br />Huile sur toile<br />50,9 x 61,5 cm",
      source:
        "Collection du Musée des beaux-arts du Canada, Ottawa<br />Don de Anne McDougall, Ottawa, 1997<br />Photo&#160;: MBAC",
    },
  },
  {
    _typename: "gallery",
    reference: ["2", "2.1", "2.2", "2.3"],
    image: ["I02_11", "I02_12", "I02_21", "I02_22", "I02_3"],
    size: 1,
    caption_en: [
      {
        body:
          "Set of painted panels [from left to right and top to bottom]:",
      },
      {
        title: "Indian Fur Traders",
        body:
          " (front and rear), c. 1930<br />Oil on beaverboard<br />137,2 x 121,9 cm",
      },
      {
        title: "Early Settlers",
        body:
          " (front and rear), c. 1930<br />Oil on beaverboard<br />137,2 x 121,9 cm",
      },
      {
        title: "Indian Camp",
        body:
          ", c. 1930<br />Oil on beaverboard mounted on plywood<br />166,3 x 185,4 cm",
        source:
          "Collection of the Leonard & Bina Ellen Art<br />Gallery, Concordia University<br />Gift of the Collection of the PSBGM Cultural<br />Heritage Foundation, 2002<br />Photos: Denis Farley and Paul Litherland",
      },
    ],
    caption_fr: [
      {
        body:
          "Ensemble de panneaux peints [de gauche à droite et de haut en bas]",
      },
      {
        title: "Commerçants de fourrures indiens",
        body:
          " (faces avant et arrière), vers 1930<br />Huile sur panneau de boisaggloméré<br />137,2 x 121,9 cm",
      },
      {
        title: "Premiers colons",
        body:
          " (faces avant et arrière), vers 1930<br />Huile sur panneau de bois aggloméré<br />137,2 x 121,9 cm",
      },
      {
        title: "Camp indien",
        body:
          ",<br/>vers 1930<br />Huile sur panneau de bois<br />aggloméré monté sur contreplaqué<br />166,3 x 185,4 cm",
        source:
          "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Don provenant de la collection de la<br />Fondation du patrimoine culturel de la CEPGM,&#160;2002<br />Photos : Denis Farley et Paul Litherland",
      },
    ],
  },
  {
    _typename: "sketchbook",
    reference: "3",
    images: "I03",
    size: 4,
    caption_en: {
      title: "Anne Savage Murals",
      body: ", a description of a set of painted panels, n.d., Anne Savage Fonds, Concordia University Archives, file 11.8.",
      source: "",
    },
    caption_fr: {
      title: "Anne Savage Murals",
      body:
        ", description d’un ensemble de panneaux peints,&#160;n.&#160;d., Fonds Anne Savage, Archives de l’Université Concordia, document 11.8.",
    },
  },
  {
    _typename: "sketchbook",
    reference: "4",
    images: "I04",
    size: 4,
    caption_en: {
      title: "",
      body: "“Young Montreal Learns Art,” <em>The Standard</em>, November 19, 1938, Anne Savage Fonds, Concordia University Archives, file 13.15.",
      source: "",
    },
    caption_fr: {
      body:
        "«&#160;Young Montreal Learns Art&#160;», <em>The Standard</em>, 19 novembre 1938, Fonds Anne Savage, Archives de l’Université Concordia, document 13.15.",
    },
  },
  {
    _typename: "sketchbook",
    reference: "5",
    images: "I05",
    size: 4,
    caption_en: {
      title: "",
      body: "Zoe Bieler, “High School Art, Teacher Anne Savage Encourages Mural Painting,” <em>The Standard</em>, January 8, 1949, Anne Savage Fonds, Concordia University Archives, file 13.4.",
      source: "",
    },
    caption_fr: {
      body:
        "Zoe Bieler, «&#160;High School Art, Teacher Anne Savage Encourages Mural Painting&#160;», <em>The Standard</em>, 8 janvier 1949, Fonds Anne Savage, Archives de l’Université Concordia, document 13.4.",
    },
  },
  {
    _typename: "thumbnail",
    reference: "6",
    image: "I06",
    size: 6,
    caption_en: {
      title: "",
      body: "Brian Moore, “Teenage Art Blooms on High School Walls,” <em>Gazette (Montreal)</em>, February 26, 1952, Anne Savage Fonds, Concordia University Archives, file 13.3.",
      source: "",
    },
    caption_fr: {
      body:
        "Brian Moore, «&#160;Teenage Art Blooms on High School Walls&#160;», <em>Gazette&#160;(Montréal)</em>, 26 février 1952, Fonds Anne Savage, Archives de l’Université Concordia, document 13.3.",
    },
  },
  {
    _typename: "thumbnail",
    reference: "7",
    image: "I07",
    size: 5,
    caption_en: {
      title: "",
      body: "Robert Ayre, “Paintings by Young Students Based on History of Own Land: A New Approach to Geography,” <em>The Standard</em>, June 7, 1941, Anne Savage Fonds, Concordia University Archives, file P146-06-01-36.",
      source: "",
    },
    caption_fr: {
      body:
        "Robert Ayre, «&#160;Paintings by Young Students Based on History of Own Land: A New Approach to Geography&#160;», <em>The Standard</em>, 7 juin 1941, Fonds Anne Savage, Archives de l’Université Concordia, document P146-06-01-36.",
    },
  },
  {
    _typename: "thumbnail",
    reference: "8",
    image: "I08",
    size: 2,
    caption_en: {
      title: "Class and Mural at Baron Byng High School",
      body: ", n.d., Anne Savage Fonds, Concordia University Archives, file P146-06-01-7.",
      source: "",
    },
    caption_fr: {
      title: "Classe d’élèves et murale à l’école secondaire Baron Byng",
      body:
        ",&#160;n.&#160;d., Fonds Anne Savage, Archives de l’Université Concordia, document P146-06-01-7.",
    },
  },
  {
    _typename: "thumbnail",
    reference: "9",
    image: "I09",
    size: 2,
    caption_en: {
      title: "Mural at Baron Byng High School",
      body: ", n.d., Anne Savage Fonds, Concordia University Archives, file P146-06-01-40.",
      source: "",
    },
    caption_fr: {
      title: "Murale à l’école secondaire Baron Byng",
      body:
        "&#160;n.&#160;d., Fonds Anne Savage, Archives de l’Université Concordia, document P146-06-01-40.",
    },
  },
  {
    _typename: "sound",
    reference: "10",
    sound: "I10",
    size: 1,
    caption_en: {
      title: "",
      body: "Arthur H. Calvin, <em>Interview with Anne Savage</em>, September 1967, Anne Savage Fonds, Concordia University Archives, file 18.3, tape 1, 00:32:40 - 00:34:03.",
      source: "",
    },
    caption_fr: {
      body:
        "Arthur H. Calvin, <em>Entretiens avec Anne Savage</em>, septembre 1967, Fonds Anne Savage, Archives de l’Université Concordia, document 18.3, cassette 1, 00:32:40 - 00:34:03.",
    },
  },
  {
    _typename: "thumbnail",
    reference: "11",
    image: "I11",
    size: 1,
    caption_en: {
      title: "",
      body: "Florence Wyle<br /><em>Deer Panel</em>, c. 1929<br />Plaster, patina<br />87 x 181,2 cm",
      source: "Art Gallery of Ontario<br />Gift of the Estates of Frances Loring and Florence Wyle, 1983<br />83/166<br />© Art Gallery of Ontario",
    },
    caption_fr: {
      body:
        "Florence Wyle<br /><em>Deer Panel</em>, vers 1929<br />Plâtre, patine<br />87 x 181,2 cm",
      source:
        "Musée des beaux-arts de l’Ontario&#160;(AGO)<br />Don des successions de Frances Loring et Florence Wyle, 1983<br />83/166<br />© Musée des beaux-arts de l’Ontario",
    },
  },
  {
    _typename: "thumbnail",
    reference: "12",
    image: "I12",
    size: 4,
    caption_en: {
      title: "Indian Fur Traders",
      body: " [front side], c.&nbsp;1930<br />Oil on beaverboard<br />137,2 x 121,9 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Gift of the Collection of the PSBGM Cultural Heritage Foundation, 2002<br />Photo: Denis Farley",
    },
    caption_fr: {
      body:
        "<em>Commerçants de fourrures indiens</em> [face avant], vers 1930<br />Huile sur panneau de bois aggloméré<br />137,2 x 121,9 cm",
      source:
        "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Don provenant de la collection de la Fondation&#160;du patrimoine culturel de la CEPGM, 2002<br />Photo&#160;: Denis Farley",
    },
  },
  {
    _typename: "thumbnail",
    reference: "13",
    image: "I13",
    size: 2,
    caption_en: {
      title: "",
      body: "Aristide Beaugrand-Champagne, Mount Royal Park Chalet, 1930-32, interior view.",
      source: "Photo: Elisabeth Otto",
    },
    caption_fr: {
      body:
        "Aristide Beaugrand-Champagne, Chalet de la montagne du parc du Mont-Royal, 1930-1932, vue intérieure.",
      source: "Photo&#160;: Elisabeth Otto",
    },
  },
  {
    _typename: "thumbnail",
    reference: "14",
    image: "I14",
    size: 2,
    caption_en: {
      title: "",
      body: "Alfred Faniel<br /><em>Jacques Cartier sur le mont Royal</em>, c. 1930-32<br />Mount Royal Park Chalet",
      source: "Photo: Elisabeth Otto",
    },
    caption_fr: {
      body:
        "Alfred Faniel<br /><em>Jacques Cartier sur le mont Royal</em>, vers 1930-1932<br />Chalet de la montagne du parc du Mont-Royal",
      source: "Photo&#160;: Elisabeth Otto",
    },
  },
  {
    _typename: "thumbnail",
    reference: "15",
    image: "I15",
    size: 4,
    caption_en: {
      title: "Indian Fur Traders",
      body: " (backside), c. 1930<br />Oil on beaverboard<br />137,2 x 121,9 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Gift of the Collection of the PSBGM Cultural Heritage Foundation, 2002<br />Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "<em>Commerçants de fourrures indiens&#160;</em> (face arrière), vers 1930<br />Huile sur panneau de bois aggloméré<br />137,2 x 121,9 cm",
      source:
        "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Don provenant de la collection de la Fondation&#160;du patrimoine culturel de la CEPGM, 2002<br />Photo&#160;: Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "16",
    image: "I16",
    size: 4,
    caption_en: {
      title: "Untitled",
      body: ", n.d.<br />Watercolour and ink on paper<br />30,3 x 22,8 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Gift of the Anne Savage Estate, 1989<br />Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "<em>Sans titre</em>,&#160;n.&#160;d.<br />Aquarelle et encre sur papier<br />30,3 x 22,8 cm",
      source:
        "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Don de la succession Anne Savage, 1989<br />Photo&#160;: Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "17",
    image: "I17",
    size: 4,
    caption_en: {
      title: "Untitled",
      body: ", n.d.<br />Pencil and watercolour on paper<br />25,3 x 19 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Gift of the Anne Savage Estate, 1989<br />Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "<em>Sans titre</em>,&#160;n.&#160;d.<br />Crayon et aquarelle sur papier <br />25,3 x 19 cm",
      source:
        "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Don de la succession Anne Savage, 1989<br />Photo&#160;: Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "18",
    image: "I18",
    size: 2,
    caption_en: {
      title: "Untitled",
      body: ", drawing from Sketchbook no. 13, c.&nbsp;1921<br />Pencil on paper<br />11,4 x 14,4 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Gift of the Anne Savage Estate, 1989<br />Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "<em>Sans titre</em>, dessin tiré du <em>Carnet de croquis no 13</em>, vers 1921<br />Crayon sur papier<br />11,4 x 14,4 cm",
      source:
        "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Don de la succession Anne Savage, 1989<br />Photo&#160;: Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "19",
    image: "I19",
    size: 2,
    caption_en: {
      title: "The Camp",
      body: ", drawing from Sketchbook no. 13, 1921<br />Pencil on paper<br />11,4 x 14,4 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Gift of the Anne Savage Estate, 1989<br />Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "<em>Le camp</em>, dessin tiré du <em>Carnet de croquis no 13</em>, vers&#160;1921<br />Crayon sur papier<br />11,4 x 14,4 cm",
      source:
        "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Don de la succession Anne Savage, 1989<br />Photo&#160;: Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "20",
    image: "I20",
    size: 5,
    caption_en: {
      title: "Untitled (Vanity Fair)",
      body: ", n.d.<br />Ink and pencil on paper<br />32,9 x 20,3 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Gift of the Anne Savage Estate, 1989<br />Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "<em>Sans titre&#160;(Vanity Fair)</em>,&#160;n.&#160;d.<br />Encre et crayon sur papier<br />32,9 x 20,3 cm",
      source:
        "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Donde la succession Anne Savage, 1989<br />Photo&#160;: Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "21",
    image: "I21",
    size: 4,
    caption_en: {
      title: "Early Settlers",
      body: " [front side], c. 1930<br />Oil on beaverboard<br />137,2 x 121,9 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Gift of the Collection of the PSBGM Cultural Heritage Foundation, 2002<br />Photo: Denis Farley",
    },
    caption_fr: {
      body:
        "<em>Premiers colons</em> [face avant], vers 1930<br />Huile sur panneau de bois aggloméré<br />137,2 x 121,9 cm",
      source:
        "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Don provenant de la collection de la Fondation&#160;du patrimoine culturel de la CEPGM, 2002<br />Photo&#160;: Denis Farley",
    },
  },
  {
    _typename: "thumbnail",
    reference: "22",
    image: "I22",
    size: 4,
    caption_en: {
      title: "Early Settlers",
      body: " (backside), c. 1930<br />Oil on beaverboard<br />137,2 x 121,9 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Gift of the Collection of the PSBGM Cultural Heritage Foundation, 2002<br />Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "<em>Premiers colons</em>&#160;(face arrière), vers 1930<br />Huile sur panneau de bois aggloméré<br />137,2 x 121,9 cm",
      source:
        "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Don provenant de la collection de la Fondation&#160;du patrimoine culturel de la CEPGM, 2002<br />Photo&#160;: Paul Litherland",
    },
  },
  {
    _typename: "sketchbook",
    reference: "23",
    images: "I23",
    size: 4,
    caption_en: {
      title: "",
      body: "Anne Savage, <em>Design Activities</em>, n.d., pamphlet written for the Protestant School Board of Greater Montreal, Anne Savage Fonds, Concordia University Archives, file 12.32.",
      source: "",
    },
    caption_fr: {
      body:
        "Anne Savage, <em>Design Activities</em>,&#160;n.&#160;d., brochure rédigée à l’attention de la Commission des écoles protestantes du Grand Montréal, Fonds Anne Savage, Archives de l’Université Concordia, document 12.32.",
    },
  },
  {
    _typename: "thumbnail",
    reference: "24",
    image: "I24",
    size: 3,
    caption_en: {
      title: "Still Life (studio)",
      body: ", c.&nbsp;1930s<br />Oil on panel<br />45,3 x 40,8 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Gift of Anne McDouglas, A.T. Galt MacDermot, Mary Drummond, Helen Leslie and John B. Claxton, 1997 <br />Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "<em>Nature morte&#160;(studio)</em>,<br/>vers 1930-1940<br />Huile sur panneau<br />45,3 x 40,8 cm",
      source:
        "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Don de Anne McDouglas, A.T. Galt MacDermot, Mary Drummond, Helen Leslie et John B. Claxton, 1997&#160;<br />Photo&#160;: Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "25",
    image: "I25",
    size: 2,
    caption_en: {
      title: "Indian Camp",
      body: ", c. 1930<br />Oil on beaverboard mounted on plywood<br />166,3 x 185,4 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Gift of the Collection of the PSBGM Cultural Heritage Foundation, 2002<br />Photo: Denis Farley",
    },
    caption_fr: {
      body:
        "<em>Camp indien</em>,<br/>vers 1930<br />Huile sur panneau de bois aggloméré monté sur contreplaqué<br />166,3 x 185,4 cm",
      source:
        "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Don provenant de la collection de la Fondation&#160;du patrimoine culturel de la CEPGM, 2002<br />Photo&#160;: Denis Farley",
    },
  },
  {
    _typename: "thumbnail",
    reference: "26",
    image: "I26",
    size: 1,
    caption_en: {
      title: "",
      body: "Kent Monkman<br /><em>The Academy</em>, 2011<br />Etching and aquatint on paper<br />Edition 22/75<br />31,5 x 51 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br />Purchase, 2013",
    },
    caption_fr: {
      body: "Kent Monkman<br /><em>The Academy</em>, 2011<br />Eau-forte et aquatinte sur papier <br />Édition 22/75<br />31,5 x 51 cm",
      source:
        "Collection de la Galerie Leonard &amp; Bina Ellen, Université Concordia<br />Achat, 2013",
    },
  },
]

export default ({ size }) => {
  const data = useStaticQuery(query)

  return <Figures data={data} figures={figs} pre="imaginer" size={size} />
}

export const query = graphql`
  query {
    I01: file(relativePath: { eq: "imaginer/I_01.jpg" }) {
      ...thumbnailImage
    }
    I02_11: file(relativePath: { eq: "imaginer/I_11.jpg" }) {
      ...thumbnailImage
    }
    I02_12: file(relativePath: { eq: "imaginer/I_14.jpg" }) {
      ...thumbnailImage
    }
    I02_21: file(relativePath: { eq: "imaginer/I_20.jpg" }) {
      ...thumbnailImage
    }
    I02_22: file(relativePath: { eq: "imaginer/I_21.jpg" }) {
      ...thumbnailImage
    }
    I02_3: file(relativePath: { eq: "imaginer/I_24.jpg" }) {
      ...thumbnailImage
    }
    I03: allFile(
      filter: {
        relativePath: { regex: "/^imaginer/I_02/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    I04: allFile(
      filter: {
        relativePath: { regex: "/^imaginer/I_03/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    I05: allFile(
      filter: {
        relativePath: { regex: "/^imaginer/I_04/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    I06: file(relativePath: { eq: "imaginer/I_05.jpg" }) {
      ...thumbnailImage
    }
    I07: file(relativePath: { eq: "imaginer/I_06.jpg" }) {
      ...thumbnailImage
    }
    I08: file(relativePath: { eq: "imaginer/I_07.jpg" }) {
      ...thumbnailImage
    }
    I09: file(relativePath: { eq: "imaginer/I_08.jpg" }) {
      ...thumbnailImage
    }
    I10: file(relativePath: { eq: "imaginer/I_09.mp3" }) {
      publicURL
    }
    I11: file(relativePath: { eq: "imaginer/I_10.jpg" }) {
      ...thumbnailImage
    }
    I12: file(relativePath: { eq: "imaginer/I_11.jpg" }) {
      ...thumbnailImage
    }
    I13: file(relativePath: { eq: "imaginer/I_12.jpg" }) {
      ...thumbnailImage
    }
    I14: file(relativePath: { eq: "imaginer/I_13.jpg" }) {
      ...thumbnailImage
    }
    I15: file(relativePath: { eq: "imaginer/I_14.jpg" }) {
      ...thumbnailImage
    }
    I16: file(relativePath: { eq: "imaginer/I_15.jpg" }) {
      ...thumbnailImage
    }
    I17: file(relativePath: { eq: "imaginer/I_16.jpg" }) {
      ...thumbnailImage
    }
    I18: file(relativePath: { eq: "imaginer/I_17.jpg" }) {
      ...thumbnailImage
    }
    I19: file(relativePath: { eq: "imaginer/I_18.jpg" }) {
      ...thumbnailImage
    }
    I20: file(relativePath: { eq: "imaginer/I_19.jpg" }) {
      ...thumbnailImage
    }
    I21: file(relativePath: { eq: "imaginer/I_20.jpg" }) {
      ...thumbnailImage
    }
    I22: file(relativePath: { eq: "imaginer/I_21.jpg" }) {
      ...thumbnailImage
    }
    I23: allFile(
      filter: {
        relativePath: { regex: "/^imaginer/I_22_B/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    I24: file(relativePath: { eq: "imaginer/I_23.jpg" }) {
      ...thumbnailImage
    }
    I25: file(relativePath: { eq: "imaginer/I_24.jpg" }) {
      ...thumbnailImage
    }
    I26: file(relativePath: { eq: "imaginer/I_25.jpg" }) {
      ...thumbnailImage
    }
  }
`
